import sumBy from 'lodash/sumBy';
import { useState, useCallback, useEffect } from 'react';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
import { Autocomplete, CircularProgress, TextField, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/system';
import moment from 'moment';

// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
import { RouterLink } from 'src/routes/components';
import {
  endpoints,
  getFetcher,
  getFetcherPrams,
  postFetcher,
  postFetcher1,
  postPramsFetcher,
} from 'src/utils/axios';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// utils
import { fTimestamp } from 'src/utils/format-time';
// _mock
import { _invoices, INVOICE_SERVICE_OPTIONS } from 'src/_mock';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import {
  useTable,
  getComparator,
  emptyRows,
  TableNoData,
  TableEmptyRows,
  TableHeadCustom,
  TableSelectedAction,
  TablePaginationCustom,
} from 'src/components/table';
//
import CustomerReceivableTableRow from '../customerReceivable-table-row';
import CustomerReceivableTableToolbar from '../customerReceivable-table-toolbar';
import CustomerReceivableFiltersResult from '../customerReceivable-table-filters-result';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Type' },
  { id: 'so_no', label: 'INV Number' },
  { id: 'createDate', label: 'Date' },
  { id: 'dueDate', label: 'Amount' },
  { id: 'balance', label: 'Balance' },
  // { id: 'action', label: 'Action' },
];

const defaultFilters = {
  name: '',
  service: [],
  status: 'all',
  startDate: null,
  endDate: null,
};

// ----------------------------------------------------------------------

export default function CustomerReceivable() {
  const theme = useTheme();

  const settings = useSettingsContext();

  const router = useRouter();

  const table = useTable({ defaultOrderBy: 'createDate' });

  const confirm = useBoolean();

  const [tableData, setTableData] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(null);
  const [currentMonthBalance, setCurrentMonthBalance] = useState(null);
  const [balance, setBalance] = useState(null);

  const [rowsPerPage, setRowsPerPages] = useState(5);
  const [totalDataSize, setTotalDataSize] = useState(100);
  const [pageNum, setPageNum] = useState(0);

  const [filters, setFilters] = useState(defaultFilters);
  const [productFieldList, setProductFieldList] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  console.log('selectedSupplierId', selectedSupplier);
  console.log('tableDataggggggg', tableData);
  console.log('tableDatagggggggfilters', filters);

  const supplierData = (supplier) => {
    setSelectedSupplier(supplier);
  };
  const dateError =
    filters.startDate && filters.endDate
      ? filters.startDate.getTime() > filters.endDate.getTime()
      : false;

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
    dateError,
  });

  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );

  const denseHeight = table.dense ? 56 : 76;

  const canReset =
    !!filters.name ||
    !!filters.service.length ||
    filters.status !== 'all' ||
    (!!filters.startDate && !!filters.endDate);

  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

  const getInvoiceLength = (status) => tableData.filter((item) => item.status === status).length;

  const getTotalAmount = (status) =>
    sumBy(
      tableData.filter((item) => item.status === status),
      'totalAmount'
    );

  const handleFilters = useCallback((name, value) => {
    // table.onResetPage();
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }, []);

  const handleDeleteRow = useCallback(
    (id) => {
      const deleteRow = tableData.filter((row) => row.id !== id);
      setTableData(deleteRow);

      table.onUpdatePageDeleteRow(dataInPage.length);
    },
    [dataInPage.length, table, tableData]
  );

  const handleDeleteRows = useCallback(() => {
    const deleteRows = tableData.filter((row) => !table.selected.includes(row.id));
    setTableData(deleteRows);

    table.onUpdatePageDeleteRows({
      totalRows: tableData.length,
      totalRowsInPage: dataInPage.length,
      totalRowsFiltered: dataFiltered.length,
    });
  }, [dataFiltered.length, dataInPage.length, table, tableData]);

  const handleEditRow = useCallback(
    (id) => {
      router.push(paths.dashboard.invoice.edit(id));
    },
    [router]
  );

  const handleViewRow = useCallback(
    (id) => {
      router.push(paths.dashboard.accountPayble.details(id));
    },
    [router]
  );

  const handleFilterStatus = useCallback(
    (event, newValue) => {
      handleFilters('status', newValue);
    },
    [handleFilters]
  );

  const handleResetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(endpoints.systemSettings.productFeildList);
        setProductFieldList(response);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // const handleSupplierChange = (event, newValue) => {
  //   if (newValue) {
  //     setSelectedSupplierId(newValue.id);
  //   } else {
  //     setSelectedSupplierId(null);
  //   }
  // };

  // get all pending sales Order
  useEffect(() => {
    async function vendorlistApicall() {
      setTableData([]);
      setTotalDataSize(0);
      setOpeningBalance(0);
      setCurrentMonthBalance(0);
      setBalance(0);

      const url = `${endpoints.invoice.payableStatement}/${pageNum}/${rowsPerPage}/0/${selectedSupplier?.id}`;
      try {
        const fromDate = moment(filters.startDate).format('YYYY-MM-DD');
        const toDate = moment(filters.endDate).format('YYYY-MM-DD');
        const params = {
          from: fromDate,
          to: toDate,
        };

        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };
        const systemData = await postFetcher1(url, params, config);

        setTableData(systemData?.data?.invoicePaymentPage?.content || []);
        setTotalDataSize(systemData.data?.invoicePaymentPage?.totalElements);
        setOpeningBalance(systemData.data?.openingBalance);
        setCurrentMonthBalance(systemData.data?.currentMonthBalance);
        setBalance(systemData.data?.balance);
      } catch (error) {
        console.error(error);
      }
    }
    vendorlistApicall();
  }, [pageNum, rowsPerPage, selectedSupplier, filters?.startDate, filters?.endDate]);

  console.log('pendingOutBoundtableData', tableData);

  const handleRowsPerPageChange = (event) => {
    // The selected page size is available in event.target.value
    const selectedPageSize = event.target.value;
    table.setRowsPerPage(selectedPageSize);
    setPageNum(0);
    console.log('Selected Page Size:', selectedPageSize);
    setRowsPerPages(selectedPageSize);
  };
  const handleChangePage = (page, num) => {
    // The selected page size is available in event.target.value
    console.log({ num });
    // table.setPage(num)
    setPageNum(num);
  };

  const [loading, setLoading] = useState(false);

  // Update data fetching effect to handle loading state
  useEffect(() => {
    async function customerlistApicall() {
      setLoading(true);
      setTableData([]);
      setTotalDataSize(0);
      setOpeningBalance(0);
      setCurrentMonthBalance(0);
      setBalance(0);

      const url = `${endpoints.salesOrder.receivableStatement}/${pageNum}/${rowsPerPage}/0/${selectedSupplier?.id}`;
      try {
        const fromDate = moment(filters.startDate).format('YYYY-MM-DD');
        const toDate = moment(filters.endDate).format('YYYY-MM-DD');
        const params = {
          from: fromDate,
          to: toDate,
        };

        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };
        const systemData = await postFetcher1(url, params, config);
        setTableData(systemData?.data?.invoicePaymentPage?.content || []);
        setTotalDataSize(systemData.data?.invoicePaymentPage?.totalElements);
        setOpeningBalance(systemData.data?.openingBalance);
        setCurrentMonthBalance(systemData.data?.currentMonthBalance);
        setBalance(systemData.data?.balance);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    customerlistApicall();
  }, [pageNum, rowsPerPage, selectedSupplier, filters?.startDate, filters?.endDate]);

  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Customer Receivable Statement"
          links={[
            {
              name: 'Dashboard',
              href: paths.dashboard.root,
            },
            {
              name: 'Customer Receivable List',
              href: paths.dashboard.customerReceivable.root,
            },
          ]}
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <Box sx={{ position: 'relative' }}>
          {loading && (
            <Box
              sx={{
                position: 'absolute',
                zIndex: 10,
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                bgcolor: 'rgba(255,255,255,0.6)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 2,
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Card sx={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
            <CustomerReceivableTableToolbar
              filters={filters}
              onFilters={handleFilters}
              dateError={dateError}
              serviceOptions={INVOICE_SERVICE_OPTIONS.map((option) => option.name)}
              supplierData={supplierData}
            />

            <Box sx={{ p: 3, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <Card sx={{ minWidth: 220, flex: 1, p: 2, bgcolor: 'error.lighter' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Opening Balance
                </Typography>
                <Typography variant="h5" sx={{ mt: 1 }}>
                  {Number(openingBalance || 0).toFixed(3)}
                </Typography>
              </Card>
              <Card sx={{ minWidth: 220, flex: 1, p: 2, bgcolor: 'warning.lighter' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Current Month Balance
                </Typography>
                <Typography variant="h5" sx={{ mt: 1 }}>
                  {Number(currentMonthBalance || 0).toFixed(3)}
                </Typography>
              </Card>
              <Card sx={{ minWidth: 220, flex: 1, p: 2, bgcolor: 'success.lighter' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Balance
                </Typography>
                <Typography variant="h5" sx={{ mt: 1 }}>
                  {Number(balance || 0).toFixed(3)}
                </Typography>
              </Card>
            </Box>

            {canReset && (
              <CustomerReceivableFiltersResult
                filters={filters}
                onFilters={handleFilters}
                onResetFilters={handleResetFilters}
                results={dataFiltered.length}
                sx={{ p: 2.5, pt: 0 }}
              />
            )}

            <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
              <TableSelectedAction
                dense={table.dense}
                numSelected={table.selected.length}
                rowCount={tableData.length}
                onSelectAllRows={(checked) =>
                  table.onSelectAllRows(
                    checked,
                    tableData.map((row) => row.id)
                  )
                }
                action={
                  <Stack direction="row">
                    <Tooltip title="Sent">
                      <IconButton color="primary">
                        <Iconify icon="iconamoon:send-fill" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Download">
                      <IconButton color="primary">
                        <Iconify icon="eva:download-outline" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Print">
                      <IconButton color="primary">
                        <Iconify icon="solar:printer-minimalistic-bold" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete">
                      <IconButton color="primary" onClick={confirm.onTrue}>
                        <Iconify icon="solar:trash-bin-trash-bold" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                }
              />

              <Scrollbar>
                <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 800 }}>
                  <TableHeadCustom
                    order={table.order}
                    orderBy={table.orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={tableData.length}
                    numSelected={table.selected.length}
                    onSort={table.onSort}
                  />

                  <TableBody>
                    {tableData.length > 0 &&
                      tableData?.map((row) => (
                        <CustomerReceivableTableRow
                          key={row.id}
                          row={row}
                          selected={table.selected.includes(row.id)}
                          onSelectRow={() => table.onSelectRow(row.id)}
                          onViewRow={() => handleViewRow(row.id)}
                          onEditRow={() => handleEditRow(row.id)}
                          onDeleteRow={() => handleDeleteRow(row.id)}
                        />
                      ))}
                  </TableBody>
                </Table>
              </Scrollbar>
            </TableContainer>

            <TablePaginationCustom
              count={totalDataSize}
              page={pageNum}
              rowsPerPage={table.rowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
              onRowsPerPageChange={handleRowsPerPageChange}
              onPageChange={handleChangePage}
              dense={table.dense}
              onChangeDense={table.onChangeDense}
            />
          </Card>
        </Box>
      </Container>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={
          <>
            Are you sure want to delete <strong> {table.selected.length} </strong> items?
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleDeleteRows();
              confirm.onFalse();
            }}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter({ inputData, comparator, filters, dateError }) {
  const { name, status, service, startDate, endDate } = filters;

  const stabilizedThis = inputData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);

  if (name) {
    inputData = inputData.filter(
      (invoice) =>
        invoice.invoiceNumber.toLowerCase().indexOf(name.toLowerCase()) !== -1 ||
        invoice.invoiceTo.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
    );
  }

  if (status !== 'all') {
    inputData = inputData.filter((invoice) => invoice.status === status);
  }

  if (service.length) {
    inputData = inputData.filter((invoice) =>
      invoice.items.some((filterItem) => service.includes(filterItem.service))
    );
  }

  if (!dateError) {
    if (startDate && endDate) {
      inputData = inputData.filter(
        (invoice) =>
          fTimestamp(invoice.createDate) >= fTimestamp(startDate) &&
          fTimestamp(invoice.createDate) <= fTimestamp(endDate)
      );
    }
  }

  return inputData;
}
